import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { adminLogout } from "./adminAuth";
import "./styles/admin.css";

export default function AdminLayout() {
    const nav = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);

    const logout = () => {
        adminLogout();
        nav("/admin/login", { replace: true });
    };

    // Close menu when route changes (optional: simple version)
    useEffect(() => {
        const close = () => setMenuOpen(false);
        window.addEventListener("hashchange", close);
        return () => window.removeEventListener("hashchange", close);
    }, []);

    return (
        <div className={`admin-shell ${menuOpen ? "menu-open" : ""}`}>
            {/* Topbar (mobile) */}
            <header className="admin-topbar">
                <button
                    className="admin-burger"
                    type="button"
                    onClick={() => setMenuOpen((v) => !v)}
                    aria-label="Open menu"
                >
                    ☰
                </button>

                <div className="admin-topbar-brand">
                    <div className="admin-logo">Z</div>
                    <div>
                        <div className="admin-title">Zubaide Admin</div>
                        <div className="admin-sub">Invoice Panel</div>
                    </div>
                </div>
            </header>

            {/* Overlay (mobile) */}
            <div
                className="admin-overlay"
                onClick={() => setMenuOpen(false)}
            />

            <aside className="admin-sidebar">
                <div className="admin-brand desktop-only">
                    <div className="admin-logo">Z</div>
                    <div>
                        <div className="admin-title">Zubaide Admin</div>
                        <div className="admin-sub">Invoice Panel</div>
                    </div>
                </div>

                <nav className="admin-nav">
                    <NavLink
                        to="/admin/customers"
                        className={({ isActive }) => (isActive ? "active" : "")}
                        onClick={() => setMenuOpen(false)}
                    >
                        Customer
                    </NavLink>
                    <NavLink
                        to="/admin/invoices"
                        className={({ isActive }) => (isActive ? "active" : "")}
                        onClick={() => setMenuOpen(false)}
                    >
                        Invoice
                    </NavLink>
                </nav>

                <button className="admin-btn ghost" onClick={logout}>
                    Logout
                </button>
            </aside>

            <main className="admin-main">
                <Outlet />
            </main>
        </div>
    );
}
